export default "__VITE_ASSET__DAoNR82H__"